<div class="px-10" [ngClass]="currentStep < 7 ? 'border-l border-lightGray2 ' : ''">
  <app-step1 *ngIf="currentStep >= 1" [class.hidden]="currentStep >= 5"></app-step1>
  <app-step2  *ngIf="currentStep >= 2" [class.hidden]="currentStep >= 5"></app-step2>
  <app-step3 (onEnd)="loadStations($event)" *ngIf="currentStep >= 3" [class.hidden]="currentStep >= 5"></app-step3>
  <app-step4 *ngIf="currentStep >= 4" [class.hidden]="currentStep >= 5"></app-step4>
  <app-step5 *ngIf="currentStep >= 5" [class.hidden]="currentStep != 5"></app-step5>
  <app-step6 *ngIf="currentStep >= 6" [class.hidden]="currentStep != 6"></app-step6>
  <app-step7 *ngIf="currentStep >= 7" [admin]="true"></app-step7>
</div>
